module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAfklEQVQoU82QsQ3DMAwE+aoyUCBRO6RPlcIxnMbLpPI4qV8LJNNIMmSAgpIJwop4HoH/h/wMyaqqMLkvJvwlQHKttb5ijJ9mdDRJckJK6QxgyTk/G2QAybuInI6YIwTgLSJzO6rq1nswqJTycM6t3vutPX8VRfIG4BJCuFpxO7h2SoedNIcvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-down.png
// module id = HZZp
// module chunks = 2